module.exports = __webpack_public_path__ + "img/jr.7bee21a0.png";